import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `KeystoreControllerStateProvider` not mounted on RN.
export default function useKeystoreControllerState(): any {
  const { state } = useController('KeystoreController' as any)
  return state as any
}
